/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import { LoadMoreObserver } from "../../../shared/LoadMoreObserver/LoadMoreObserver";
import { getCurrencySymbol } from "../../../Utils/services.js";
import { AppTranslation } from "../../../i18n/useAppTranslation.js";

class PatientsInsightDetailReport extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    this.state = {
      appointmentLang: languageData.appointments,
      globalLang: languageData.global,
      salesLang: languageData.sales,
      languageData: languageData.business_insights,
      showLoadingText: false,
      action_type: props.action_type ? props.action_type : "active",
    };
  }

  dismissCloseDetail = () => {
    this.props.dismissCloseDetail({
      showGeneralReport: true,
      [this.props.detailReportFlag]: false,
      business_insight_child_id: 0,
    });
  };

  render() {
    return (
      <div className="juvly-section setting-setion m-b-10 m-t-10">
        <div className="juvly-container memberShip-revenue p-b-20">
          <div className="juvly-title no-margin">
            {this.props.grammar + " (" + this.props.clinicName + ")"}{" "}
            <a
              onClick={() => this.dismissCloseDetail()}
              className="pull-right crossIcon m-b-10"
            >
              <img alt="" src="/images/close.png" />
            </a>
          </div>
          <div className="mainRightActions">
            <a
              className="easy-link relative"
              onClick={() => this.props.downloadData()}
            >
              <i className="fa fa-download"></i> Download Excel
            </a>
          </div>
        </div>
        <div className="table-responsive clients-table no-border">
          <table className="table-updated  table-min-width no-td-border no-hover">
            <thead className="table-updated-thead">
              <tr>
                {this.props.tableColumns &&
                  this.props.tableColumns.length > 0 &&
                  this.props.tableColumns.map((tobj, tidx) => {
                    const columnLabel =
                      tobj === "bi_client_name" ? (
                        <AppTranslation.Common path="label.patientName" />
                      ) : (
                        this.state.languageData[tobj]
                      );

                    return (
                      <th key={tidx} className="table-updated-th">
                        {columnLabel}
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody className="ajax_body">
              {this.props.detailReportListData &&
                this.props.detailReportListData.length > 0 &&
                this.props.detailReportListData.map((robj, ridx) => {
                  return (
                    <tr key={ridx} className="table-updated-tr">
                      <>
                        {this.props.tableColumns &&
                          this.props.tableColumns.length > 0 &&
                          this.props.tableColumns.map((tobj, tidx) => {
                            return (
                              <td
                                key={ridx + `_` + tidx}
                                className={"table-updated-td break-all"}
                              >
                                {" "}
                                {[
                                  "bi_amount_of_money_spent",
                                  "bi_refund",
                                  "bi_average_transection",
                                  "bi_amount_of_funds_spent",
                                  "bi_discount",
                                ].indexOf(tobj) > -1
                                  ? getCurrencySymbol()
                                  : null}
                                {robj[tobj]}
                              </td>
                            );
                          })}
                      </>
                    </tr>
                  );
                })}
              {this.props.detailReportListData &&
                this.props.detailReportListData.length <= 0 &&
                this.props.parentState.showLoader === false && (
                  <tr className="table-updated-tr">
                    <td
                      className="table-updated-td no-record no-float"
                      colSpan={10}
                    >
                      {
                        this.props.parentState.businessInsightLang
                          .bi_no_record_found
                      }
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
          <LoadMoreObserver
            hasMore={this.props.parentState.detailReportHasNextPage}
            loadMore={this.props.loadMore}
            isLoading={this.props.parentState.showLoader}
          />
        </div>
      </div>
    );
  }
}

export default PatientsInsightDetailReport;
